import React from "react";
import Icon from "./Icon";

export interface ButtonProps {
  onClick?: any;
  href?: string;
  icon?: React.ReactNode | string;
  children?: React.ReactNode;
  className?: string;
  iconPosition?: "left" | "right" | "top";
  disabled?: any;
  type?: "button" | "submit" | "reset" | "application/pdf" | any;
  target?: "_new" | "_blank" | "_self" | "_parent";
  download?: string;
  style?: React.CSSProperties;
  iconSize?: "small" | "normal" | "large";
  WrapperComponent?: React.ElementType;
}

const Button: React.FC<ButtonProps> = React.forwardRef(
  (
    {
      onClick,
      href,
      icon,
      children,
      iconPosition = "left",
      iconSize = "normal",
      className,
      disabled,
      WrapperComponent = "button",
      ...rest
    },
    ref,
  ) => {
    const wrappedIcon: React.ReactNode =
      typeof icon === "string" ? <Icon icon={icon} /> : icon;
    return (
      <WrapperComponent
        href={href}
        ref={ref as any}
        onClick={onClick}
        className={className || "unchained-button"}
        disabled={disabled}
        aria-disabled={disabled}
        data-icon-size={iconSize}
        data-icon-position={!children ? "center" : iconPosition}
        {...rest}
      >
        {(iconPosition === "left" || iconPosition === "top" || !children) &&
          wrappedIcon}
        {children}
        {iconPosition === "right" && wrappedIcon}
      </WrapperComponent>
    );
  },
);

Button.displayName = "Button";

export default Button;
